// extracted by mini-css-extract-plugin
export var copyIcon = "_s7-2";
export var discountCard = "_s7-0";
export var discountCode = "_s7-3";
export var discountContent = "_s7-1";
export var loadingCard = "_s7-4";